<template>
  <button @click="newUnit" :aria-label="$t('buttons.newUnit')" :title="$t('buttons.newUnit')" class="action" id="new-button">
    <plus-circle-icon size="1.5x" class="custom-class"></plus-circle-icon>
    <span>{{ $t('buttons.newUnit') }}</span>
  </button>
</template>

<script>

import { PlusCircleIcon } from 'vue-feather-icons';

export default {
  name: 'new-unit',
  components: {
    PlusCircleIcon
  },
  methods: {
    newUnit: async function () {
      this.$store.commit('showHover', 'create-unit');
    }
  }
};
</script>